module.exports = __webpack_public_path__ + "media/dashboard/assets/images/channels/viber-2f42bfea7b8023899d33f817301861d0.png";